export default "__VITE_ASSET__wI9o$jwe__"